import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { zoomIn, zoomOut, toggleHeadquarters } from 'data/MapSettings/actions';
import Switch from './components/Switch';
import SquareButton from './components/SquareButton';
import './index.scss';
import { ReactComponent as PlusIcon } from './icon-plus.svg';
import { ReactComponent as MinusIcon } from './icon-minus.svg';

/*
 * Types definition
 */
const propTypes = {
    headquartersVisible: PropTypes.bool,
    onZoomIn: PropTypes.func,
    onZoomOut: PropTypes.func,
    onSwitch: PropTypes.func,
};

const defaultProps = {
    headquartersVisible: false,
    onZoomIn: null,
    onZoomOut: null,
    onSwitch: null,
};

/*
 * Component
 */
class MapControls extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleOnSwitch = this.handleOnSwitch.bind(this);
        this.handleZoomIn = this.handleZoomIn.bind(this);
        this.handleZoomOut = this.handleZoomOut.bind(this);
    }

    handleOnSwitch() {
        const { onSwitch } = this.props;
        if (onSwitch) {
            onSwitch();
        }
    }

    handleZoomIn() {
        const { onZoomIn } = this.props;
        if (onZoomIn) {
            onZoomIn();
        }
    }

    handleZoomOut() {
        const { onZoomOut } = this.props;
        if (onZoomOut) {
            onZoomOut();
        }
    }

    render() {
        const { headquartersVisible } = this.props;

        return (
            <div className="map-controls">
                <Switch
                    callback={this.handleOnSwitch}
                    active={headquartersVisible}
                    label="Show acai bros hq"
                    name="acai-hq"
                />
                <SquareButton callback={this.handleZoomOut} icon={MinusIcon} />
                <SquareButton callback={this.handleZoomIn} icon={PlusIcon} />
            </div>
        );
    }
}

MapControls.propTypes = propTypes;
MapControls.defaultProps = defaultProps;

const mapDispatchToProps = dispatch => ({
    onZoomIn: () => dispatch(zoomIn()),
    onZoomOut: () => dispatch(zoomOut()),
    onSwitch: () => dispatch(toggleHeadquarters()),
});

const mapStateToProps = state => ({
    headquartersVisible: state.mapSettings.headquarters,
});

export default connect(mapStateToProps, mapDispatchToProps)(MapControls);
